import React, { useEffect } from 'react'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import GuestCheckoutInfo from './GuestCheckoutInfo';

export default function CardForm({user, card, actionType, onClose, onSave, saving, stripeAccounts, team, cardFormat, cardType}) {
  const [publicCard, setPublicCard] = React.useState(card)
  const [openGuestCheckoutInfo, setOpenGuestCheckoutInfo] = React.useState(false);
  const url = publicCard.url && publicCard.url.length > 5 ? publicCard.url : 'Save card to generate URL'

  useEffect(() => {
    if (!team.stripe_uid && publicCard.payment_method == 'stripe') {
      setPublicCard({ ...publicCard, payment_method: 'external_payment_method' });
    }

    if (cardFormat == 'single') {
      setPublicCard({...publicCard, card_type: cardType, card_format: cardFormat});
    }

    setPublicCard({...publicCard, team_id: team.id});
  }, [])

  const copyToClipboard = () => {
    navigator.clipboard.writeText(url)
    Alert.show('notice', 'Copied public card url to clipboard')
  }

  const handleFieldUpdate = (event) => {
    const value = event.target.value;
    let newFields = publicCard.settings["fields"] || [];
    if (event.target.checked) {
      newFields.push({ id: value });
    } else {
      _.remove(newFields, (n) => n.id == value);
    }

    setPublicCard((publicCard) => {
      return { ...publicCard, settings: { ...publicCard.settings, fields: newFields } };
    });
  };

  const pageFields = (publicCard.settings["fields"] || []).map((field) => field.id)

  const handlePaymentType = (checked) => {
    if (checked) {
      if (team.stripe_uid)
        setPublicCard({ ...publicCard, payment_method: 'stripe' });
      if (!team.stripe_uid)
        Alert.show(
          "notice",
          "You have to connect to Stripe in the settings to use Stripe payments"
        );
    }

    if (!checked) {
      setPublicCard({ ...publicCard, payment_method: 'external_payment_method' });
    }
  };

  return (
    <div>
    <div 
      className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal"
      style={{ overflowY: 'auto', display: 'block' }}
    >
        <div className="bg-white mx-auto rounded shadow p-5 text-center" style={{maxWidth: '1150px'}}>
            <h2>{actionType == 'editing' ? 'Edit Public Card' : 'Create Public Card'}</h2>

            <div className="form-group w-100 text-left">
              <div className="input-group">
                <input className="form-control" placeholder="Auto generated by server" type="text" name="card_url" id="card_url" value={url} disabled/>
                <div className="input-group-append">
                    <button className="btn btn-light btn-border" type="button" onClick={copyToClipboard} disabled={!publicCard.url}><i className="fa fa-clipboard"></i></button>
                </div>
              </div>

            </div>

            <div className="text-left">
              <div className='row'>
                <div className='col-md-7'>
                  <div className="form-group">
                    <label htmlFor="title">Title</label>
                    <input
                      className="form-control"
                      placeholder="E.g. Support Student"
                      type="text"
                      name="title"
                      id="title"
                      value={publicCard.title}
                      onChange={(e) => {
                        const val = e.target.value;
                        setPublicCard({...publicCard, title: val});
                      }}
                    />
                  </div>

                  {publicCard.use_payments && publicCard.payment_method == 'external_payment_method' &&
                    <div className="form-group">
                        <label htmlFor="text">Payment Portal Link</label>
                        <input
                          className="form-control"
                          placeholder="example.com"
                          type="text"
                          name="text"
                          id="text"
                          value={publicCard.payment_redirect_link}
                          onChange={(e) => {
                            const val = e.target.value;
                            setPublicCard({...publicCard, payment_redirect_link: val});
                          }}
                        />
                    </div>
                  }

                  {publicCard.use_payments && publicCard.donation_type == 'monthly' &&
                    <div className="form-group">
                      <label htmlFor="donation_amount">Donation Amount (USD)</label>
                      <input
                        className="form-control"
                        placeholder="200"
                        type="number"
                        name="donation_amount"
                        id="donation_amount"
                        value={publicCard.donation_amount}
                        onChange={(e) => {
                          const val = e.target.value;
                          setPublicCard({...publicCard, donation_amount: val});
                        }}
                      />
                    </div>
                  }

                  <div className="form-group">
                    <div>
                      <label className="form-label">Visible Fields</label>
                    </div>
                    <div className="selectgroup selectgroup-pills">
                      {publicCard.available_fields &&
                        publicCard.available_fields.map((field) => (
                          <label key={field.id} className="selectgroup-item">
                            <input
                              type="checkbox"
                              name="value"
                              value={field.id}
                              className="selectgroup-input"
                              onChange={handleFieldUpdate}
                              checked={pageFields.includes(field.id.toString())}
                            />
                            <span className="selectgroup-button">
                              {field.name}
                            </span>
                          </label>
                        ))}
                    </div>
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className="form-group">
                      <label>View Only</label>
                      <div>
                        <ToggleSwitch
                          small
                          id="view_only"
                          checked={publicCard.view_only}
                          onChange={(checked) => {
                            setPublicCard({ ...publicCard, view_only: checked });
                          }}
                        />
                        <label htmlFor="view_only">
                          {publicCard.view_only
                            ? "Enabled"
                            : "Disabled"}
                        </label>
                      </div>
                    </div>
                    
                    <div className="form-group">
                      <label>Enable Guest Checkout (No {team.donor_title} Profile Created)</label>
                      <div>
                        <ToggleSwitch
                          small
                          id="enable_guest_checkout"
                          checked={publicCard.enable_guest_checkout}
                          onChange={(checked) => {
                            if (checked) {
                              setOpenGuestCheckoutInfo(true);
                            } else {
                              setPublicCard({ ...publicCard, enable_guest_checkout: checked })
                            }
                          }}
                          disabled={!publicCard.use_payments || publicCard.view_only}
                        />
                        <label htmlFor="enable_guest_checkout">
                          {publicCard.enable_guest_checkout
                            ? "Enabled"
                            : "Disabled"}
                        </label>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Generate QR Code</label>
                      <div>
                        <ToggleSwitch
                          small
                          id="generate_qr_code"
                          checked={publicCard.generate_qr_code}
                          onChange={(checked) => {
                            setPublicCard({ ...publicCard, generate_qr_code: checked })
                          }}
                        />
                        <label htmlFor="generate_qr_code">
                          {publicCard.generate_qr_code
                            ? "Enabled"
                            : "Disabled"}
                        </label>
                      </div>
                    </div>


                    <div className="form-group">
                      <label>Payments</label>
                      <div>
                        <ToggleSwitch
                          small
                          id="use_payments"
                          checked={publicCard.use_payments}
                          onChange={(checked) => {
                            if (!checked) {
                              setPublicCard({...publicCard, enable_guest_checkout: false, use_payments: false})
                            } else {
                              setPublicCard({ ...publicCard, use_payments: checked });
                            }
                          }}
                        />
                        <label htmlFor="use_payments">
                          {publicCard.use_payments
                            ? "Using Payments"
                            : "Payments Disabled"}
                        </label>
                      </div>
                    </div>

                    {publicCard.use_payments &&
                      <div className="form-group">
                        <label>Payment Type</label>
                        <div>
                          <ToggleSwitch
                            small
                            id="payment_type"
                            checked={publicCard.payment_method == 'stripe'}
                            onChange={(checked) => {
                              handlePaymentType(checked);
                            }}
                          />
                          <label htmlFor="payment_type">
                            {publicCard.payment_method == 'stripe'
                              ? "Using Stripe Payments"
                              : "Using Team Payments"}
                          </label>
                        </div>
                      </div>
                    }

                    {publicCard.use_payments && publicCard.payment_method == 'stripe' &&
                      <div className="form-group">
                        <label>Pass Processing Fee</label>
                        <div>
                          <ToggleSwitch
                            small
                            id="pass_processing_fee"
                            checked={publicCard.pass_processing_fee}
                            onChange={(checked) => {
                              setPublicCard({...publicCard, pass_processing_fee: checked});
                              setIsDirty(true);
                            }}
                          />
                          <label htmlFor="pass_processing_fee">
                            {publicCard.pass_processing_fee
                              ? "Enabled"
                              : "Disabled"}
                          </label>
                        </div>
                      </div>
                    }

                    {publicCard.use_payments &&
                      <div className="form-group">
                        <label htmlFor="target_type">Donation Type</label>
                        <select
                          value={publicCard.donation_type}
                          onChange={(e) => {
                            const val = e.target.value;
                            setPublicCard({ ...publicCard, donation_type: val });
                          }}
                          className="form-control capybara-page-type"
                          id='target_type'
                        >
                          <option value="monthly">Monthly</option>
                          <option value="one_time">One Time</option>
                        </select>
                      </div>
                    }

                    {publicCard.use_payments && publicCard.payment_method == 'stripe' && (
                      <div className="form-group">
                        <label htmlFor="stripe_accounts">Stripe Account</label>
                        <select
                          value={publicCard.stripe_id}
                          onChange={(e) => {
                            const val = e.target.value;
                            setPublicCard((publicCard) => {
                              return { ...publicCard, stripe_id: val };
                            });
                          }}
                          className="form-control"
                        >
                          <option value="">
                            {team.stripe_account_name} (main)
                          </option>
                          {stripeAccounts.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                </div>
              </div>
            </div>

            <div className="pt-3">
                <button onClick={() => onSave(publicCard)} type="button" className="btn btn-primary mr-2" disabled={saving}>
                {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                  {actionType == 'editing' ? 'Update' : 'Save'}
                </button>

                <button onClick={onClose} type="button" className="btn btn-danger mr-2" disabled={saving}>
                    Cancel
                </button>
            </div>
        </div>
    </div>
    {openGuestCheckoutInfo && 
          <GuestCheckoutInfo 
            cancel={() => setOpenGuestCheckoutInfo(false)} 
            proceed={() => {
              setPublicCard({ ...publicCard, enable_guest_checkout: true });
              setOpenGuestCheckoutInfo(false);
            }} 
          />
        }
  </div>
  )
}
